export const UI = {
    Button: {
        Admin: {
            CompleteForm: 'admin.complete-form',
            AddButton: 'admin.add-button',
            ConfirmDelete: 'admin.confirm-delete',
            AddRecipient: 'admin.add-recipient',
            GetTargetedRecipient: 'admin.get-targeted-recipients',
            CreateEvent: 'admin.create-event',

            LogIn: {
                LogIn: 'admin.log-in.log-in',
            },

            TopBar: {
                ProfileDropdown: 'admin.top-bar',
                Profile: 'admin.top-bar.profile',
                SignOut: 'admin.top-bar.sign-out',
            },

            Aside: {
                Administration: 'admin.aside.administration',
                Broadcast: 'admin.aside.broadcast',
                ContactUs: 'admin.aside.contact-us',
                Documents: 'admin-aside.documents',
                Groupings: 'admin-aside.groupings',
                Messages: 'admin-aside.messages',
                Projects: 'admin.aside.projects',
                Properties: 'admin.aside.properties',
                Residents: 'admin.aside.residents',
                SharedFacilities: 'admin.aside.shared-facilities',
                Staff: 'admin.aside.staff',
                TicketAttributes: 'admin.aside.ticket-attributes',
                TicketManagement: 'admin.aside.ticket-management',
                Tickets: 'admin.aside.tickets',
                Units: 'admin.aside.units',
                UnitTypes: 'admin.aside.unit-types',
                UnitGroups: 'admin.aside.unit-groups',
                Events: 'admin.aside.events',
                WaitingList: 'admin.aside.waiting-list',
                Applicants: 'admin.aside.applica',
                VacantUnits: 'admin.aside.vacant-units',
                MultiTenancy: {
                    AccountSwitch: 'admin.aside.multi.tenancy.account-switch',
                },
            },

            Buildings: {
                AddBuilding: 'admin.buildings.add-building',
            },

            Broadcast: {
                AddNotification: 'admin.broadcast.add-notification',
            },

            Documents: {
                AddDocument: 'admin.documents.add-document',
                AddContract: 'admin.documents.add-contract',
            },

            Messages: {
                AddConversationDialogue: 'admin.messages.add-conversation-dialogue',
            },

            Profile: {
                UpdateProfileImage: 'admin.profile.update-profile-image',
                UpdateSettings: 'admin.profile.update-settings',
                SaveProfileImage: 'admin.profile.save-image',
                Tab: 'admin.profile.admin-tab',
                ToggleEmailNotificationTickets: 'admin.profile.toggle-email-notification-tickets',
                ToggleEmailNotificationMessage: 'admin.profile.toggle-email-notification-messages',
            },

            Projects: {
                TypeName: 'admin.projects.type-name',
                CreateProject: 'admin.projects.create-project',
                AddImage: 'admin.projects.add-image',
                EditProject: 'admin.projects.edit-project',
                Edit: {
                    RemoveImage: 'admin.projects.edit.remove-image',
                    UploadImage: 'admin.projects.edit.upload-image',
                    SaveProject: 'admin.projects.edit.save-image',
                },
                AddEvent: 'admin.projects.create-event',
                Event: {

                },
            },

            Staff: {
                Languages: {
                    AddLanguage: 'admin.staff.language.add-language',
                    RemoveLanguage: 'admin.staff.language.remove-language',
                },

                AddStaff: 'admin.staff.add-staff',
                CompleteAddStaff: 'admin.staff.complete-add-staff',
                EditStaff: 'admin.staff.edit-staff',
                CreateStaff: 'admin.staff.create-staff',
                DeleteStaff: 'admin.staff.delete-staff',
                CompleteEditStaff: 'admin.staff.complete-edit',
                CancelEditStaff: 'admin.staff.cancel-edit',
            },

            SharedFacilities: {
                AddNewFacility: 'admin.shared-facilities.add-new-facility',
                ViewFacility: 'admin.shared-facilities.view-facility',
                DeleteActiveFacility: 'admin.shared-facilities.delete-facility',

                Create: {
                    CreateFacility: 'admin.shared-facilitites.create.create-facility',
                },
            },

            Tickets: {
                AddTicket: 'admin.tickets.add-ticket',
                AddTicketChatNote: 'admin.tickets.chat.note.add-note',
            },

            UnitGroups: {
                AddUnitGroup: 'admin.unit-groups.addUnitGroup',
                Remove: {
                    FacilityManager: 'admin.unit-groups.remove.facility-manager',
                },
            },

            UnitType:  {
                Add: 'admin.unit-type.add',
                UploadDocument: 'admin.unit-type.upload-document',
                Create: 'admin.unit-type.create',
                DeleteUnit: 'admin.unit-type.delete-unit',
                AddFloorPlan: 'admin.unit-type.add-floor-plan',
                EditFloorPlan: 'admin.unit-type.edit-floor-plan',
                UploadFloorPlan: 'admin.unit-type.upload-floor-plan',
                SelectImage: 'admin.unit-type.select-image',
            },
            Unit: {
                AddUnit: 'admin.unit.add-unit',
                AddGrouping: 'admin.unit.add-grouping',
                CreateUnit: 'admin.unit.create-unit',
                EditUnit: 'admin.unit.edit-unit',
                SaveUnit: 'admin.unit.save-unit',
                TableUnitID: 'admin.unit.save-unit',
                DeleteUnit: 'admin.unit.delete-unit',

                UnitCard: {
                    AddPrimaryTenant: 'admin.unit-card.add-primary-tenant',
                    AddAdditionalTenant: 'admin.unit.unit-card.add-additional-tenant',

                    AddTenant: {
                        Save: 'admin.unit-card.add-tenant.save',
                    },

                    AddUpcomingTenant: {
                        Save: 'admin.unit-card.add-upcoming-tenant.save',
                        Complete: 'admin.unit-card.add-upcoming-tenant.complete',
                        Next: 'admin.unit-card.add-upcoming-tenant.next',
                    },
                },

            },

            Grouping: {
                Save: 'admin.grouping.save',
            },

            EventLogs: {
                MarkAllEventLogsAsSeen: 'admin.event-logs.mark-all-as-seen',
            },

            FlexibleTable: {
                FilterButton: 'admin.flexibleTable.filter-button',
                SortingButton: 'admin.flexibleTable.sorting-button',
                Views: {
                    CreateNewView: 'admin.flexible-table.views.create-new',
                    SaveCurrentView: 'admin.flexible-table.views.save-current-view',
                    ViewList: 'admin.flexible-table.views.view-list',
                    ViewListItem: 'admin.flexibleTable.views.view-list-item',
                    DeleteIcon: 'admin.flexible-table.views.delete-icon',
                    VisibleColumns: 'admin.flexible-table.views.visible-columns',
                    DefaultIcon: 'admin.flexible-table.views.default-icon',

                    AddViewModal: {
                        Cancel: 'admin.flexibleTable.views.create-modal.cancel',
                        Confirm: 'admin.flexibleTable.views.create-modal.confirm',
                    },

                    DeleteViewModal: {
                        Cancel: 'admin.flexibleTable.views.delete-modal.cancel',
                        Confirm: 'admin.flexibleTable.views.delete-modal.confirm',
                    },
                },
                FiltrationPopup: {
                    Select: 'admin.flexibleTable.views.filtration-popup.select',
                },
            },
        },

        Mobile: {

            GeneralOk: 'mobile.General-ok',

            Aside: {
                Dashboard: 'mobile.aside.dashboard',
                Messages: 'mobile.aside.messages',
                Calender: 'mobile.aside.calendar',
                Documents: 'mobile.aside.documents',
                Tickets: 'mobile.aside.tickets',
                Contacts: 'mobile.aside.contacts',
                SharedFacility: 'mobile.aside.shared-facility',
                SignOut: 'mobile.aside.sign-out',
                Wallet: 'mobile.aside.wallet',
                Links: 'mobile.aside.links',
            },

            Footer: {
                AsideMenu: 'mobile.footer.aside-menu',
                HomeAssistant: 'mobile.footer.home-assistant',
                Messages: 'mobile.footer.messages',
                Dashboard: 'mobile.footer.dashboard',
                Tickets: 'mobile.footer.tickets',
                Units: 'mobile.footer.units',
                StaffAssistant: 'mobile.footer.staff-assistant',
            },

            Header: {
                RightButton: 'mobile.header.right-button',
                LeftButton: 'mobile.header.left-button',
            },

            AvailableUpdate: {
                Now: 'mobile.available-update.now',
                Later: 'mobile.available-update.later',
            },

            HomeAssistant: {
                ReportIssue: 'mobile.home-assistant.report-issue',
            },

            SharedFacilities: {
                BookNow: 'mobile.shared-facility.book-now',
                BookFacility: 'mobile.shared-facility.book-facility',
                SaveDate: 'mobile.shared-facility.save-date',
                SaveTime: 'mobile.shared-facility.save-time',
                Next: 'mobile.shared-facility.next',
                ConfirmBooking: 'mobile.shared-facility.confirm-booking',
                GoToBookings: 'mobile.shared-facilities.go-to-booking',
                SelectBooking: 'mobile.shared-facilities.select-booking',
            },

            CorporationLinks: {
                ReadMore: 'mobile.corporation-links.read-more',
            },

            Menu: {
                Close: 'mobile.menu.close',
                AccountSwitch: 'mobile.menu.account-switch',
            },
        },
    },

    Field: {
        Admin: {
            Broadcast: {
                AddNotification: {
                    Title: 'admin.add-notification.title',
                    Message: 'admin.add-notification.message',
                    UploadImage: 'admin.add-notification.upload-image',
                    Create: 'admin.add-notification.create',
                    NotificationCheckmark: 'admin.add-notification.notification-checkmark',
                    EmailCheckmark: 'admin.add-notification.email-checkmark',
                    SmsCheckmark: 'admin.add-notification.sms-checkmark',
                    SelectDate: 'admin.add-notification.select-date',
                    CommunicationChannel: 'admin.add-notification.communication-channel-select',
                },
            },

            Grouping: {
                Title: 'admin.grouping.title',
                Type: 'admin.grouping.type',
                Project: 'admin.grouping.project',
                UnitGroup: 'admin.grouping.unit-group',
                AddGroupingTable: 'admin.grouping.add-grouping-table',
                Checkbox: 'admin.grouping.checkbox',
            },

            Documents: {
                AddDocument: {
                    Category: 'admin.documents.add-documents.category',
                    Title: 'admin.documents.add-documents.Title',
                    Description: 'admin.documents.add-documents.description',
                    Language: 'admin.documents.add-documents.language',
                    UploadDocument: 'admin.documents.add-documents.upload-document',
                    CreateDocument: 'admin.documents.add-documents.create-document',
                },

                AddContract: {
                    Category: 'admin.documents.add-documents.category',
                    Title: 'admin.documents.add-documents.title',
                    Description: 'admin.documents.add-documents.description',
                    Language: 'admin.documents.add-documents.language',
                    UploadContract: 'admin.documents.add-documents.upload-document',
                    CreateContract: 'admin.documents.add-documents.create-document',
                },

                AddRecipient: {
                    SelectProject: 'admin.add-recipient.select-project',
                    SelectGroup: 'admin.add-recipient.select-group',
                    SearchRecipient: 'admin.add-recipient.search-recipient',
                    RecipientTable: 'admin.add-recipient.recipient-table',
                    RecipientCheckAll: 'admin.add-recipient.recipient-check-all',
                    RecipientCheckbox: 'admin.add-recipient.recipient-checkbox',
                    Add: 'admin.add-recipient.add',
                },
            },

            Events: {
                AddEvent: {
                    Title: 'admin.add-event.title',
                    Description: 'admin.add-event.description',
                    RequiresResponse: 'admin.add-event.requires-response',
                    AddressVisibility: 'admin.add-event.address-visibility',
                    Address: 'admin.add-event.address',
                    City: 'admin.add-event.city',
                    Zip: 'admin.add-event.zip',
                    Country: 'admin.add-event.country',
                    Create: 'admin.add-event.create',
                    UploadImage: 'admin.add-event.upload-image',
                },
            },

            LogIn: {
                Email: 'admin.log-in.email',
                Password: 'admin.log-in.password',
            },

            Messages: {
                ConversationList: 'admin.messages.converstion-list',
                AddConversationDialogue: {
                    Search: 'admin.messages.add-conversation-dialogue.search',
                    AddConversation: 'admin.messages.add-conversation',
                },
                Feed: {
                    Text: 'admin.messages.feed.text',
                    UploadFile: 'admin.messages.feed.upload-file',
                    UploadImage: 'admin.messages.feed.upload-image',
                    SendMessage: 'admin.messages.feed.send-message',
                },
                ConversationInfo: {
                    Title: 'admin.messages.feed.title',
                },
                ConversationStatus: {
                  DropDown: 'admin.messages.conversation-status.dropdown',
                  ConversationType: 'admin.messages.conversation-status.conversations-type',
                  MarkAsClosed: 'admin.messages.conversation-status.mark-as-closed',
                  ReopenConversation: 'admin.messages.conversation-status.re-open-conversation',
                },
            },

            Tickets: {
                SelectProject: 'admin.ticket-attributes.select-project',
                AddTicket: {
                    Title: 'admin.add-ticket.title',
                    TicketMessage: 'admin.add-ticket.ticket-message',
                    UploadImage: 'admin.add-ticket.upload-image',
                    SelectProject: 'admin.add-ticket.select-project',
                    TicketProperty: 'admin.add-ticket.ticket-property',
                    TicketReceiver: 'admin.add-ticket.ticket-receiver',
                    TicketType: 'admin.add-ticket.ticket-type',
                    TicketCategory: 'admin.add-ticket.ticket-category',
                    TicketAssignee: 'admin.add-ticket.ticket-Assignee',
                    TicketPriority: 'admin.add-ticket.ticket-priority',
                    TicketStatus: 'admin.add-ticket.ticket-status',
                    SelectWatcher: 'admin.add-ticket.select-watcher',
                    Add: 'admin.add-ticket.add',
                },
            },

            TicketAttributes: {
                SelectProject: 'admin.ticket-attributes.select-project',
                SelectTicket: 'admin.ticket-attributes.select-ticket',
                TicketType: 'admin.ticket-attributes.ticket-type',
                CreateCategory: 'admin.ticket-attributes.create-category',
                CreateInquiry: 'admin.ticket-attributes.create-inquiry',
                NewInquiry: {
                    Title: 'admin.ticket-attributes.new-inquiry.title',
                    Priority: 'admin.ticket-attributes.new-inquiry.Priority',
                    Message: 'admin.ticket-attributes.new-inquiry.message',
                    AllowContactCheckbox: 'admin.ticket-attributes.new-inquiry.allow-contact-checkbox',
                    Create: 'admin.ticket-attributes.new-inquiry.create',
                },
                NewCategory: {
                    Title: 'admin.ticket-attributes.new-category.title',
                    RoleAssignee: 'admin.ticket-attributes.new-category.role-assignee',
                    AssigneeUser: 'admin.ticket-attributes.new-category.assignee-user',
                    Create: 'admin.ticket-attributes.new-category.create',
                },
                EditCategory: {
                    Title: 'admin.ticket-attributes.edit-category.title',
                    RoleAssignee: 'admin.ticket-attributes.edit-category.role-assignee',
                    AssigneeUser: 'admin.ticket-attributes.edit-category.assignee-user',
                    Edit: 'admin.ticket-attributes.edit-category.edit',

                },
            },

            Profile: {
                FirstName: 'admin.profile.first-name',
                Surname: 'admin.profile.surname',
                Email: 'profile.profile.email',
                Phone: 'admin.profile.phone',
            },

            Projects: {
                TypeName: 'admin.projects.type-name',
                SelectOwner: 'admin.projects.select-owner',
                TypeDescription: 'admin.projects.type-description',
                ProjectName: 'admin.projects.project-name',
                Edit: {
                    Description: 'admin.projects.edit.description',
                    Name: 'admin.projects.edit.name',
                    Owner: 'admin.projects.edit.owner',

                },
            },

            SharedFacilities: {
                SelectFacility: 'admin.shared-facilities.select-facility',
                SelectProject: 'admin.shared-facicilities.select-project',
                Create: {
                    SelectGroup: 'admin.shared-facilities.select-group',
                    SelectType: 'admin.shared-facilities.select-type',
                    AddName: 'admin.shared-facilities.add-name',
                    AddInfo: 'admin.shared-facilites.add-info',
                    CheckboxAvailability: 'admin.shared-facilities.checkbox-availability',
                    AddPrice: 'admin.shared-facilities.add-price',
                    SelectedBookingOption: 'admin.shared-facilities.select-booking-option',
                    SelectedBookingStart: 'admin.shared-facilities.select-booking-start',
                    SelectedBookingEnd: 'admin.shared-facilities.select-booking-end',
                    SelectedBookingDays: 'admin.shared-facilities.select-booking-days',
                    GoBack: 'admin.shared-facilities.go-back',
                    BlockDuration: 'admin.shared-facilities.block-duration',
                    MinBlocks: 'admin.shared-facilities.minimum-blocks',
                    MaxBlocks: 'admin.shared-facilities.maximum-blocks',
                    MaxBlocksBooking: 'admin.shared-facilities.maximum-booking-blocks',
                    MinBlocksBooking: 'admin.shared-facilities.minimum-booking-blocks',
                    SelectWatcher: 'admin.shared-facilities.select-watcher',
                },

                Edit: {

                },

            },

            Staff: {
                AddFirstName: 'admin.staff.add-first-name',
                AddLastName: 'admin.staff.add-last-name',
                AddEmail: 'admin.staff.add-email',
                AddPhone: 'admin.staff.add-phone',
                AddTitle: 'admin.staff.add-title',
                AddRole: 'admin.staff.add-role',
                AddProject: 'admin.staff.add-project',
                AddGroup: 'admin.staff.add-group',
                AddasTenantContact: 'admin.staff.add-as-tenant-contact',
                EditasTenantContact: 'admin.staff.edit-as-tenant-contact',
                AddContactMessage: 'admin.staff.add-contact-message',
                EditContactMessage: 'admin.staff.edit-contact-message',
                AddContactPhone: 'admin.staff.add-contact-phone',
                EditContactPhone: 'admin.staff.edit-contact-phone',
                AddContactSharedFacility: 'admin.staff.add-contact-shared-facility',
                EditContactSharedFacility: 'admin.staff.edit-contact-shared-facility',
                LanguageDropdown: 'admin.staff.add-language-dropdown',
                AddLanguage: 'admin.staff.add-language',
                RemoveLanguage: 'admin.staff.remove-language',
                AddRoleDescription: 'admin.staff.add-role-description',

                EditStaffForm: {
                    FirstName: 'admin.edit-staff.first-name',
                    LastName: 'admin.edit-staff.last-name',
                    Email: 'admin.edit-staff.email',
                    Phone: 'admin.edit-staff.phone',
                    Title: 'admin.edit-staff.title',
                },
            },

            UnitGroups: {
               AddUnitGroup: {
                   SelectProject: 'admin.add-unit-group.select-project',
                   Name: 'admin.add-unit-group.name',
                   FacilityManager: 'admin.add-unit-group.facility-manager',
                   Create: 'admin.add-unit-group.create',
                   Save: 'admin.add-unit-group.save',
                   Cancel: 'admin.add-unit-group.cancel',
               },
            },

            UnitType: {
                SelectOwner: 'admin.unit-type.select-owner',
                Name: 'admin.unit-type.name',
                Area: 'admin.unit-type.area',
                Rooms: 'admin.unit-type.rooms',
                Description: 'admin.unit-type.description',
            },

            Unit: {
                TableUnitID: 'admin.unit.table-unit-id',
                UnitID: 'admin.unit.unit-id',
                Address: 'admin.unit.address',
                City: 'admin.unit.city',
                ZipCode: 'admin.unit.zip-code',
                Floor: 'admin.unit.floor',
                Country: 'admin.unit.country',
                Rent: 'admin.unit.rent',
                Deposit: 'admin.unit.deposit',
                Water: 'admin.unit.water',
                Heating: 'admin.unit.heating',
                Area: 'admin.unit.area',
                Rooms: 'admin.unit.rooms',
                Power: 'admin.unit.power',
                Internet: 'admin.unit.internet',
                PrepaidRent: 'admin.unit.prepaid-rent',
                TotalPaid: 'admin.unit.total-paid',
                FutureRent: 'admin.unit.future-rent',
                UnitType: 'admin.unit.unit-type',
                VacantFromDate: 'admin.unit.vacant-from-date',
                ReleaseDate: 'admin.unit.release-date',
                MoveInDate: 'admin.unit.move-in-date',
                Variant: 'admin.unit.variant',
                UnitGroup: 'admin.unit.unit-group',
                UnitManager: 'admin.unit.unit-manager',
                MaterialTabs: 'admin.unit.material-tabs',

                UnitCard: {
                    Edit: 'admin.unit.unit-card.edit',
                    ToggleTenant: 'admin.unit.unit-card.toggle-tenant',

                    AddTenant: {
                        FirstName: 'admin.unit-card.add-tenant.first-name',
                        LastName: 'admin.unit-card.add-tenant.last-name',
                        Email: 'admin.unit-card.add-tenant.email',
                        Phone: 'admin.unit-card.add-tenant.phone',
                    },

                    AddUpcomingTenant: {
                        FirstName: 'admin.unit-card.add-upcoming-tenant.first-name',
                        LastName: 'admin.unit-card.add-upcoming-tenant.last-name',
                        Email: 'admin.unit-card.add-upcoming-tenant.email',
                        Phone: 'admin.unit-card.add-upcoming-tenant.phone',
                    },
                },
            },

            FlexibleTable: {
                Views: {
                    AddViewModal: {
                        ViewName: 'admin.flexibleTable.create-modal.view-name',
                    },
                },
            },
        },


        Quasar: {
            ColumStyleSelect: 'quasar.table.colum-style-select',
            RowsPerPage: 'quasar.table.rows-per-page',
        },

        Mobile: {
            SharedFacilities: {
                BookingDate: 'Mobile.shared-facility.booking-date',
                BookingHour: 'Mobile.shared-facility.booking-hour',
                SelectBookingDate: 'Mobile.shared-facility.select-booking-date',
                SelectBookingHour: 'Mobile.shared-facility.select-booking-hour',
                TimeBooking: 'mobile.shared-facility.time-booking',
                ViewBooking: 'mobile.shared-facilities.view-booking',
            },

            HomeAssistant: {
                ReportIssue: {
                    Title: 'mobile.report-issue.title',
                    Description: 'mobile.report-issue.Description',
                    AttachFile: 'mobile.report-issue.attach-file',
                    SelectType: 'mobile.report-issue.select-type',
                    SelectCategory: 'mobile.report-issue.select-category',
                    Submit: 'mobile.report-issue.submit',
                },
            },

            Aside: {
                Language: {
                    Language: 'mobile.aside.language.language',
                    Dropdown: 'mobile.aside.language.dropdown',
                    Select: 'mobile.aside.language.select',
                },
            },

            Header: {
                Search: 'mobile.header.search',
                MessagesClosed: 'mobile.header.messages-closed',
                MessagesOpen: 'mobile.header.messages-opne',
            },

            Conversation: {
                Header: 'mobile.conversation.header',
                LastMessage: 'mobile.conversation.last-message',
                List: 'mobile.conversation.list',
            },

            UserInfo: {
                DirectMessage: 'mobile.user-info.direct-message',
            },

            Documents: {
                All: 'mobile.documents.all',
                Contracts: 'mobile.documents.contracts',
                Documents: 'mobile.documents.documents',
            },

            Assistant: {
                TypeDescription: 'mobile.assistant.type-description',
                BookFacility: 'mobile.assistant.book-facility',
            },
        },

        MultiTenancy: {
            AccountSwitch: 'multi.tenancy.account-switch',
        },
    },

    Element: {
        Admin: {
            FlexibleTable: {
                Body: 'admin.flexible-table.body',
                FiltrationPopup: {
                    Body: 'admin.flexible-table.filtration-pop-up.body',
                },
            },
        },
    },
};
